import React from 'react';
import { Grid, TextField, Typography } from '@mui/material';
export const DISCLOSURE_FIELDS = [{
  key: 'providerPhone',
  label: 'Provider phone'
}, {
  key: 'billingAgentDisclosure',
  label: 'Billing agent disclosure'
}, {
  key: 'leakServiceContact',
  label: 'Leak or service contact'
}];
export const SubmeterDisclosures = _ref => {
  let values = _ref.values,
    onChange = _ref.onChange,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    style: {
      marginBottom: 12
    }
  }, "Disclosures"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light",
    style: {
      marginBottom: 12
    }
  }, "Shown for every cycle of this utility. A value in the uploaded CSV replaces it for that month."), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 24
  }, DISCLOSURE_FIELDS.map(_ref2 => {
    let key = _ref2.key,
      label = _ref2.label;
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      key: key
    }, /*#__PURE__*/React.createElement(TextField, {
      id: "submeter-disclosure-".concat(key),
      label: label,
      variant: "outlined",
      fullWidth: true,
      value: values[key],
      onChange: event => onChange(key, event.target.value)
    }));
  })));
};